<template>
  <div class="wrapper">
    <b-row>
      <b-col>
        <b-card header="Campaigns">
        <div class="filter-bar ui basic segment grid">
          <div class="ui form">
            <div class="inline field">
              <label>Search for:</label>
              <input type="text" v-model="filterText" class="three wide column" @keyup.enter="doFilter" placeholder="code, description, name">
              <button class="ui primary button" @click="doFilter">Go</button>
              <button class="ui button" @click="resetFilter">Reset</button>
            </div>
          </div>
        </div>
        <vuetable :multi-sort="true" multi-sort-key="ctrl" ref="vuetable" :api-url="api_url" :fields="fields" pagination-path="" :per-page="perPage" @vuetable:pagination-data="onPaginationData" :append-params="moreParams" :http-options="httpOptions" >
          <template slot="actions" slot-scope="props">
            <div class="table-button-container">
              <button class="btn btn-info" @click="editCampaign(props.rowData)"><i class="fa fa-edit"></i> Edit</button>&nbsp;&nbsp;
              <button class="btn btn-danger" @click="deleteCampaign(props.rowData._id)"><i class="fa fa-remove"></i> Delete</button>&nbsp;&nbsp;
            </div>
          </template>
        </vuetable>
        <div class="vuetable-pagination ui basic segment grid">
          <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
          <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
        </div>
        </b-card>
        <b-card header="Add a new Campaign">
          <form action="#" method="POST" class="createCampaign">
            <div class="form-group">
              <label>Campaign Name:</label>
              <input class="form-control"  @click="getMaxCampaignsCode" type="text" placeholder="Ex: Soccer" required="required" v-model="cmpName">
            </div>
            <div class="form-group">
              <label>Campaign Code:</label>
              <input class="form-control" type="text" placeholder="Ex: 2" required="required" v-model="cmpCode">
            </div>
            <div class="form-group">
              <label for="#cmpDescription">Campaign Description:</label>
              <textarea class="form-control" id="cmpDescription" v-model="cmpDescription"></textarea>
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-secondary form-control" @click.prevent="saveCampaign">Save</button>
            </div>
          </form>
        </b-card>
      </b-col>
    </b-row>
    <edit-campaign-modal></edit-campaign-modal>
  </div>
</template>

<script>

import Vue from 'vue'
import { Bus } from '@/main'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import collect from 'collect.js'
import EditCampaignModal from '@/views/modals/EditCampaignModal'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    'edit-campaign-modal': EditCampaignModal
  },
  data () {
    return {
      httpOptions: {
        baseURL: this.$http.defaults.baseURL,
        headers: this.$http.defaults.headers.common
      },
      perPage: 10,
      cmpName: '',
      cmpDescription: '',
      cmpCode: '',
      moreParams: {},
      campaignmakerCode: '',
      filterText: '',

      fields: [
        {
          name: '__sequence', // <----
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned'
        },
        {
          name: 'name',
          title: 'Name',
          sortField: 'name'
        },
        {
          name: 'code',
          title: 'Code',
          sortField: 'code'
        },
        {
          name: 'description',
          title: 'Description'
        },
        {
          name: 'created_at',
          title: 'Created',
          sortField: 'created_at',
          callback: 'formatDate'
        },
        {
          name: '__slot:actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }

      ],
      api_url: '',
      sortOrder: [
        {
          field: 'created_at',
          sortField: 'created_at',
          direction: 'desc'
        }
      ]
    }
  },
  methods: {
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value === null)
        ? ''
        : this.$moment(value, 'YYYY-MM-DD').format(fmt)
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData) // <----
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    saveCampaign () {
      if (this.cmpCode && this.cmpDescription && this.cmpName) {
        this.$http.post(`${this.$api_url}/campaign/create`, { code: this.cmpCode, description: this.cmpDescription, name: this.cmpName }).then((success, error) => {
          if (success) {
            this.reloadTable()
            this.cmpDescription = ''
            this.cmpName = ''
            this.cmpCode = ''
          }
          if (error) {
            alert('Duplicate Campaign code!')
          }
        })
      }
    },
    reloadTable () {
      this.$refs.vuetable.refresh()
    },
    deleteCampaign (id) {
      if (prompt('Are you sure? Type "delete" if yes!') === 'delete') {
        this.$http.delete(`${this.$api_url}/campaign/delete/${id}`, { id: id }).then((success) => {
          this.reloadTable()
          alert('Campaign code deleted!')
        })
      } else {
        alert('Campaign code not deleted!')
      }
    },
    editCampaign (data) {
      Bus.$emit('editCampaign', data)
      this.$bvModal.show('campaign-edit')
    },
    getMaxCampaignsCode () {
      this.$http.get(`${this.$api_url}/campaigns/all`).then((campaigns) => {
        if (campaigns.data) {
          campaigns = campaigns.data
          let maxCode = collect(campaigns).max('code') || 0
          maxCode = maxCode === '-Infinity' ? 0 : maxCode
          this.cmpCode = maxCode + 1
        } else {
          this.cmpCode = 1
        }
      })
    },
    doFilter () {
      this.moreParams = {
        filter: this.filterText
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    resetFilter () {
      this.moreParams = {}
      this.filterText = ''
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    }
  },
  created () {
    this.api_url = this.$api_url + '/campaigns'
    Bus.$on('campaignUpdated', () => {
      this.reloadTable()
    })
  },
  beforeDestroy () {
    Bus.$off('campaignUpdated')
  }
}
</script>
